<template>
	<aModal ref="mdNewDoc" title="Documento" size="sm" static>
		<div slot="body">
			<b>Titulo</b>
			<input type="text" v-model="data.titulo" class="form-control" />
			<br />
			<b>Modalidade</b>
			<select v-model="data.modalidade" class="form-control">
				<option value="PROPOSTA_SMS">PROPOSTA SMS</option>
				<option value="PROPOSTA_PADRAO">PROPOSTA PADRÃO</option>
				<option value="PROPOSTA_OFFSHORE">PROPOSTA OFFSHORE</option>
				<option value="PROPOSTA_MARITIMO">PROPOSTA OFFSHORE</option>
				<option value="CONTRATO_SMS">CONTRATO SMS</option>
				<option value="CONTRATO_PADRAO">CONTRATO PADRÃO</option>
				<option value="CONTRATO_OFFSHORE">CONTRATO OFFSHORE</option>
				<option value="CONTRATO_MARITIMO">CONTRATO MARÍTIMO</option>
				<option value="OS">ORDEM DE SERVICO</option>
				<option value="OUTROS">OUTROS</option>
			</select>
			<br />
			<b>Departamentos</b>
			<DropDraw
				:asset="assets.deptos"
				title="titulo"
				v-model="data.deptos"
			/>
			<br />
			<b>Modelo</b>
			<label
				class="btn btn-warning btn-block"
				:disabled="progress != 100"
				@click="$refs.btnUpload.open()"
			>
				<i v-if="progress == 100" class="fa fa-upload"></i>
				<i v-else class="fa fa-spin fa-spinner"></i>
				Upload do modelo
				<span v-if="progress != 100">({{ progress }}%)</span>
			</label>
			<sUpload
				ref="btnUpload"
				path="models_documents"
				accept=".docx"
				@progress="(p) => (progress = p)"
				@complete="(p) => (data.link = p)"
			/>
			<br />
		</div>
		<div slot="footer">
			<aBtn
				text="cancelar"
				icon="close"
				@click="$refs.mdNewDoc.close()"
			/>
			<aBtn
				text="Salvar"
				type="primary"
				icon="save"
				@click="save"
				:disabled="data.link == null"
			/>
		</div>
	</aModal>
</template>
<script>
	import aModal from 'modal';
	import DropDraw from 'app/drop-draw';

	import aBtn from 'btn';
	import clone from 'js/clone';
	import sUpload from 'app/upload';
	import WBS from 'js/http';
	import { mapState } from 'vuex';
	import toastr from 'toastr';

	let reset = {
		titulo: '',
		deptos: [],
		modalidade: 'PROPOSTA_SMS',
		autor: '',
		data: 'now()',
		link: null,
	};

	export default {
		name: 'mdNewDocument',
		components: { aModal, aBtn, sUpload, DropDraw },
		props: ['assets'],
		data() {
			return {
				data: clone(reset),
				progress: 100,
			};
		},
		computed: {
			...mapState({
				uid: (s) => s.user_data.uid.uid,
			}),
		},
		methods: {
			open(data = null) {
				if (data == null) this.data = clone(reset);
				else this.data = clone(data);
				this.$refs.mdNewDoc.open();
			},
			save() {
				this.data.autor = this.uid;
				WBS.send('private-save-modelsDocuments', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Documento Salvo com sucesso!');
						this.$emit('update');
						this.$refs.mdNewDoc.close();
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/models/documents/components/modal-new-document.vue